import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { InspectionSubjectLink, PlaceLink } from 'utils/link';
import DeleteMutation from 'mutations/inspection/delete';
import Confimation from 'components/form/confirmation';

const DeleteButton = ({ inspection, space }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.inspection.deleted');
      inspection.inspectionSubject
        ? navigate(InspectionSubjectLink(inspection.inspectionSubject.id))
        : navigate(PlaceLink(inspection.place.id));
    },
    onError: () => {
      setError('error.inspection.delete');
    },
  });

  return (
    <Confimation
      title={<FormattedMessage id="header.inspection.delete" />}
      description={<FormattedMessage id="confirmation.inspection.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: inspection.id } });
      }}
    >
      <Button
        color="error"
        variant="outlined"
        disabled={deleteMutationData.loading || !space.adminRole}
      >
        <FormattedMessage id="button.delete" />
      </Button>
    </Confimation>
  );
};

export default DeleteButton;
